import React from "react";
import { ActionIcon, rem } from '@mantine/core';
import { IconDots, IconTrash, IconEdit } from "@tabler/icons-react";
import { MantineMenu, MantineMenuDropdown, MantineMenuItem, MantineMenuTarget } from "../../../components/mantine/menu";

const ActionMenu = (props:any) => {
    const { handleEdit, handleDelete, setSelectedRows, item }=props
    return (
        <MantineMenu transitionProps={{ transition: 'pop' }} withArrow position="bottom-end" withinPortal>
            <MantineMenuTarget>
                <div style={{ textAlign: 'right' }}>
                    <ActionIcon variant="subtle" color="gray">
                        <IconDots style={{ width: rem(16), height: rem(16) }} />
                    </ActionIcon>
                </div>
            </MantineMenuTarget>
            <MantineMenuDropdown>
                <MantineMenuItem
                    leftSection={<IconEdit style={{ width: rem(16), height: rem(16) }} stroke={1.5} />}
                    onClick={() => { handleEdit(); setSelectedRows(item); }}
                >
                    Edit
                </MantineMenuItem>
                <MantineMenuItem
                    leftSection={<IconTrash style={{ width: rem(16), height: rem(16) }} stroke={1.5} />}
                    onClick={() => {handleDelete();setSelectedRows(item); }}
                >
                    Delete
                </MantineMenuItem>
            </MantineMenuDropdown>
        </MantineMenu>
    );
};


export default ActionMenu;

